import ErroresDataService from "../services/ErroresDataService";

export default function ErrorHandlerByComponent(infoError){
    const error = formatErrorStackTrace(infoError);
    const errorSave = prepareDataError(error);
    registerError(errorSave);
}

export function ErrorHandlerHTTP(infoError){
    const error = formatErrorMessage(infoError);
    const errorSave = prepareDataError(error);
    registerError(errorSave);
}

function formatErrorMessage(error){
    let msg = `An anomaly has been detected in: ${error.config.method.toUpperCase()} request method directed to the ${error.config.url} endpoint. `;
    if(error.message.includes("Network")) msg += "Please verify if the link and request are correct."
    msg += `\n${error.stack}`;
    return {
        categoria: 'Critical',
        mensaje: '12051',
        stackTrace: msg,
    }
}

/**
 * Función encargada de asignar el mensaje de error para el stackTrace del registro.
 * @param {*} error objeto del error obtenido de la petición.
 * @returns mensaje personalizado del error.
 * Nota: Se ha generado el mensaje del error en inglés para homologar el idioma con el que se obtienen los errores
 * que devuelve el navegador.
 */
function formatErrorStackTrace(infoError){
    const {error, location, url} = infoError;

    const errorSplit = error.stack.split('\n');
    const msgError = errorSplit[0] + errorSplit[1];
    const stack = `An error was found at component or project lifecycle level:\n${msgError}, detected in the section: "${location}", in the address: ${url} `;
    
    return {
        categoria: "Warning",
        mensaje: error.message,
        stackTrace: stack,
    }
}

/**
 * Función encargada de preparar All el error obtenido para registrarlo dentro de
 * la coleccion errores.
 * @param {*} error mensaje de error del  stackTrace.
 * @returns objeto con la informacion completa del error.
 */
function prepareDataError(error){
    return  {
        categoria: error.categoria,
        fechaCreacion: new Date(),
        proyecto: "Web",
        mensaje: error.mensaje,
        stackTrace: error.stackTrace,
        infoDispositivo: getInfoDevice(),
        usuario: JSON.parse(sessionStorage.getItem("usuarioLogueado")),
    };
}

/**
 * Función encargada de generar la información completa del dispositivo
 * que se estaba usando cuando se generó el error.
 * @returns informacion completa del dispositivo en cuestión.
 * Nota: Se ha generado la información descriptiva del dispositivo en inglés para
 * homologar el idioma en el que se registro el error obtenido.
 */
function getInfoDevice(){
    const infoDevice = sessionStorage.getItem("logDevice");
    const arrDevice = infoDevice.split(',');
    return `The error was found when using the ${arrDevice[0]} device with known IP address: ${arrDevice[1]}, through the ${arrDevice[2]} browser.`;
}

/**
 * Función que permite registrar el error generado por componente.
 * @param {*} dataError objeto del error a registrar
 */
async function registerError(dataError){
    try{
        const key = sessionStorage.getItem('key')
        await ErroresDataService.registrar(dataError, key);
    }catch(error){
        console.error({error})
    }
}